import { Button } from '@doda/io-react/common';
import { FC } from 'react';
import styles from './index.module.scss';

/**
 * ConfirmDisplay コンポーネントのプロパティ
 */
interface Props {
  /** 表示するラベル */
  label: string;
  /** 削除ボタンがクリックされたときのハンドラー */
  onClickDelete: () => void;
  /** 確認表示の状態を設定する関数 */
  setIsShowConfirm: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * ConfirmDisplay コンポーネント
 * @param {Props} props - ConfirmDisplay コンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const ConfirmDisplay: FC<Props> = ({
  label,
  onClickDelete,
  setIsShowConfirm,
}) => {
  return (
    <div className={styles.confirmDisplay}>
      <div className={styles.confirmDisplay__inner}>
        <p>{label}をすべて削除してもよろしいですか</p>
        <div className={styles.confirmDisplay__btnWrap}>
          <Button as="button" size="S" onClick={onClickDelete} variant="green">
            削除する
          </Button>
          <Button
            as="button"
            size="S"
            onClick={(e) => {
              e.stopPropagation();
              setIsShowConfirm(false);
            }}
            variant="outline_gray"
          >
            いいえ
          </Button>
        </div>
      </div>
    </div>
  );
};
